module.exports = __webpack_public_path__ + "static/media/Step4.31d4f67f.png";